import React from 'react';
import Link from '../../../shared/Link/Link';

import ItemSlider from '../../../shared/ItemSlider/ItemSlider';
import ProductThumbnail from '../../../shared/ProductThumbnail/ProductThumbnail';
import Arrow from '../../../shared/Icons/Arrow';

import './SpecialOffers.scss';
import { connect } from 'react-redux';

const SpecialOffers = props => {
  const ViewAllLink = ({ isTop = false }) => {
    return (
      <Link
        to="/prodotti-in-offerta"
        className={`link-view-all ${isTop ? 'top' : 'bottom'}`}
      >
        <span>Vedi tutte le offerte</span>
        {isTop && <Arrow />}
      </Link>
    );
  };

  const renderTotalButtons = () => {
    const { primaryColor, isMobile } = props;
    return (
      <Link
        to="/prodotti-in-offerta"
        className={`btn ${
          isMobile ? 'btn-inverse' : 'btn-primary btn-thick btn-cart'
        }`}
        style={{
          color: '#fff',
          backgroundColor: primaryColor,
          borderColor: primaryColor,
          opacity: 1,
          width: '100%',
          fontWeight: 900,
          marginRight: 16,
          marginLeft: 16,
        }}
      >
        ALTRI PRODOTTI IN SCONTO
      </Link>
    );
  };

  const renderSpecialOffer = () => {
    const { isMobile } = props;
    return (
      <div>
        {!isMobile && (
          <div className="desktop-special-offer">
            <SpecialOffersDesktop />
          </div>
        )}
        {isMobile && (
          <div className={'mobile-special-offer'}>
            <SpecialOffersMobile />
          </div>
        )}
      </div>
    );
  };

  const SpecialOffersDesktop = () => {
    return (
      <div>
        <ViewAllLink isTop />
        <ItemSlider
          loading={props.loading}
          title="Prodotti in sconto"
          primaryColor={props.primaryColor}
          uiVariant={props.uiVariantThumbnail}
        >
          {props.products.map(product => {
            return (
              <ProductThumbnail
                key={product.id}
                product={product}
                list="Product slider"
              />
            );
          })}
        </ItemSlider>
        <ViewAllLink />
      </div>
    );
  };

  const SpecialOffersMobile = () => {
    return (
      <div>
        <div className="mobile-special-offer-title">Prodotti in sconto</div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          {props.products.map((product, index) => {
            if (index < 8) {
              return (
                <div style={{ width: '48%' }}>
                  <ProductThumbnail
                    key={product.id}
                    product={product}
                    list="Product slider"
                    spaceStar={6}
                  />
                </div>
              );
            }
          })}
          {renderTotalButtons()}
        </div>
      </div>
    );
  };

  return (
    <div className="container">
      <div className="special-offers">{renderSpecialOffer()}</div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
  };
}

export default connect(mapStateToProps, {})(SpecialOffers);
